import { Component, Input, OnInit, HostListener } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { ProfileComponent } from "../profile/profile.component";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-truck-sidebar",
  templateUrl: "./truck-sidebar.component.html",
  styleUrls: ["./truck-sidebar.component.css"],
})
export class TruckSidebarComponent implements OnInit {
  @Input() profileDetails = "";
  tripType: any = "-1";
  token: any;
  profilePic: any = "";
  truckOwner: any;
  dashboardArray: any = [];
  Matdialogref!: MatDialogRef<ProfileComponent>;
  local_storage_data: any;
  preOrderType: any;

  public opened = true;
  public mode: 'over' | 'push' | 'side' = 'side';
  public isMobile = false;

  constructor(
    private router: Router,
    private services: TruckOwnerService,
    private matDialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    if (window.innerWidth <= 991) {
      this.mode = 'over';
      this.isMobile = true;
      this.opened = false;
    } else {
      this.mode = 'side';
      this.isMobile = false;
      this.opened = true;
    }
  }

  ngOnInit(): void {
    this.checkScreenSize();
    this.token = sessionStorage.getItem("to_token");
    this.truckOwnerGet();
    this.dashboardGet();
    this.local_storage_data = "";
    this.preOrderType = "";
    this.local_storage_data = sessionStorage.getItem("preorder");

    this.preOrderType = sessionStorage.getItem("preorder_setting");

    let tripType = sessionStorage.getItem("tripType");
    if (!tripType || tripType == "preOrders") {
      this.tripType = "preOrders";
      this.router.navigateByUrl("transporter/pre-orders");
    } else {
      this.tripType = tripType;
      switch (tripType) {
        case "notifications":
          this.router.navigateByUrl("transporter/notifications");
          break;
      }
    }
    if (this.preOrderType == "preOrderSetting") {
      this.tripType = "preOrderSetting";
      this.local_storage_data = "true";
      this.router.navigateByUrl("transporter/pre-order-settings");
    }

    sessionStorage.removeItem("tripType");
    this.getProfile();
    document.addEventListener("keydown", this.preventEscClose, true);
  }

  ngOnDestroy(): void {
    document.removeEventListener("keydown", this.preventEscClose, true);
  }

  getTripsList(selectedTripType: any) {
    this.tripType = selectedTripType;
    sessionStorage.setItem("tripType", this.tripType);
    if (this.isMobile) {
      this.opened = false;
    }
    switch (this.tripType) {
      case "preOrders":
        sessionStorage.setItem("preorder", "true");
        sessionStorage.removeItem("preorder_setting");
        this.router
          .navigateByUrl("/", { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl("transporter/pre-orders");
          });
        // this.router.navigateByUrl("transporter/pre-orders");
        break;
      case "trucks":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/trucks");
        break;
      case "drivers":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/drivers");
        break;
      case "deliveryOrders":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/delivery-orders");
        break;
      case "mapping":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/mapping");
        break;
      case "driverOrders":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/driver-orders");
        break;
      case "orders":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/orders");
        break;
      case "payments":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/payments");
        break;
      case "track":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/track");
        break;
      case "reports":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/reports");
        break;
      case "help":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("/?target=support");
        break;
      case "notifications":
        sessionStorage.removeItem("preorder");
        sessionStorage.removeItem("preorder_setting");
        this.router.navigateByUrl("transporter/notifications");
        break;
    }
  }

  GoToOrders() {
    this.router.navigateByUrl("transporter/orders");
  }

  GoToProfile() {
    sessionStorage.removeItem("preorder_setting");
    sessionStorage.removeItem("preorder");
    this.router.navigateByUrl("transporter/profile");
  }

  logout() {
    sessionStorage.removeItem("to_token");
    this.services.logoutTransporter(this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.router.navigateByUrl("/");
          this.snackBar.open("Account logout successfully", "Success", {
            duration: 3000,
          });
        }
      },
      (error) => {
        {
          this.router.navigateByUrl("/");
          sessionStorage.removeItem("to_token");
        }
      }
    );
  }

  truckOwnerGet() {
    this.services.GettruckOwner(this.token).subscribe((response: any) => {
      this.truckOwner = response.body.data;
    });
  }

  public getProfile() {
    this.services.profileGet(this.token).subscribe((response: any) => {
      this.profilePic = response.body.data.profile_pic;
    });
  }

  dashboardGet() {
    this.services.dashboard(this.token).subscribe((response: any) => {
      this.dashboardArray = response.body.data;
    });
  }

  toggleSidebar() {
    this.opened = !this.opened;
  }

  onOpenedChange(event: boolean) {
    this.opened = event;
  }

  preventEscClose = (event: KeyboardEvent): void => {
    if (
      (event.key === "Escape" || event.keyCode === 27) &&
      (event.target as HTMLElement).closest(".sidebar")
    ) {
      event.stopPropagation();
    }
  };
}

